<div *ngIf="steps?.length > 0" class="steps-container">
  <div *ngFor="let step of steps; let i = index" class="step">
    <mat-progress-bar
      mode="determinate"
      [value]="isStepActive(i) ? 100 : 0"
    ></mat-progress-bar>
  </div>
</div>
